import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Ocurrió un error. Inténtalo nuevamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// --- 401 handling: try a single token refresh, then retry the original request ---
const SKIP_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/forgot-password", "/auth/reset-password"];
let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    if (!config || !response || response.status !== 401) return Promise.reject(error);
    const url = config.url || "";
    if (config._retried || SKIP_REFRESH.some((p) => url.includes(p))) return Promise.reject(error);
    config._retried = true;
    try {
      if (!refreshPromise) {
        refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
      }
      await refreshPromise;
      return api(config);
    } catch (e) {
      return Promise.reject(error);
    }
  }
);

export default api;
